import mixpanel from 'mixpanel-browser';

let initialized = false;

export function initializeMixpanel() {
	const token = process.env.REACT_APP_MIXPANEL_TOKEN;
	if (!token) {
		return false;
	}

	if (!initialized) {
		mixpanel.init(token);
		initialized = true;
	}

	return true;
}

export function trackMixpanelEvent(event: string, properties?: Record<string, unknown>) {
	if (initializeMixpanel()) {
		mixpanel.track(event, properties);
	}
}

export function identifyMixpanelUser(userId: string) {
	if (initializeMixpanel()) {
		mixpanel.identify(userId);
	}
}
